export const URL_CONFIG = {
  DEV_URL: "https://osafe-api.odishamining.in/",
  IMG_URL: "https://osafe-api.odishamining.in/uploads/",
};
